import { render } from "./McustomerGroupCreate.vue?vue&type=template&id=01329fc2&scoped=true"
import script from "./McustomerGroupCreate.vue?vue&type=script&lang=js"
export * from "./McustomerGroupCreate.vue?vue&type=script&lang=js"

import "./McustomerGroupCreate.vue?vue&type=style&index=0&id=01329fc2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01329fc2"]])

export default __exports__